/* DLT: small photos fill their frame (Nov 2, 2026).
   About 2,000 products only have ~200px images. DLT chose to stretch them to
   fill the box for now (slightly soft) instead of showing a tiny centered image.
   Long-term fix: replace them with high-res photos (tracked in the project log).
   - Main image / gallery (<img>): scale up to fit the box without cropping.
   - Card thumbnails / hero photos (background images): fill the box (cover). */
(function(){
  var SEL = '.dlt-thumb, .dlt-cat-hero-photo, .dlt-search-thumb, .dlt-fp-thumb, #dlt-main-image, .dlt-gallery-thumbs img';
  var seen = typeof WeakMap === 'function' ? new WeakMap() : null;
  function srcOf(el){
    if (el.tagName === 'IMG') return el.currentSrc || el.src;
    var m = (el.style.backgroundImage || '').match(/url\(["']?([^"')]+)["']?\)/);
    return m ? m[1] : '';
  }
  function fit(el){
    var src = srcOf(el);
    if (!src || src.indexOf('dlt-image-coming-soon') > -1) return;
    if (seen && seen.get(el) === src) return;
    if (seen) seen.set(el, src);
    var im = new Image();
    im.onload = function(){
      if (srcOf(el) !== src) return;
      var w = el.clientWidth, h = el.clientHeight;
      var small = im.naturalWidth < w * 0.98 || im.naturalHeight < h * 0.98;
      if (el.tagName === 'IMG'){
        if (small){ el.style.objectFit = 'contain'; el.style.width = '100%'; el.style.height = '100%'; }
        else { el.style.objectFit = ''; }
      } else {
        el.style.backgroundSize = 'cover';
        el.style.backgroundRepeat = 'no-repeat';
        el.style.backgroundPosition = 'center';
      }
    };
    im.src = src;
  }
  function scan(root){ (root || document).querySelectorAll(SEL).forEach(fit); }
  function start(){
    scan();
    if (window.MutationObserver){
      new MutationObserver(function(muts){
        muts.forEach(function(m){
          if (m.type === 'attributes' && m.target.matches && m.target.matches(SEL)) fit(m.target);
          else if (m.type === 'childList') m.addedNodes.forEach(function(n){ if (n.nodeType === 1){ if (n.matches(SEL)) fit(n); scan(n); } });
        });
      }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'src'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
